import Vue from "vue";
import App from "./App.vue";
import router from "./router";

/* Icons */
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowLeft,
  faArrowRight,
  faBars,
  faBrush,
  faCheck,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCloudUploadAlt,
  faExclamationCircle,
  faEyeDropper,
  faFileAlt,
  faGift,
  faGlobe,
  faLock,
  faMapMarkerAlt,
  faSearch,
  faShoppingBag,
  faStoreAlt,
  faSync
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
Vue.component("font-awesome-icon", FontAwesomeIcon);

import { faInstagram } from "@fortawesome/free-brands-svg-icons";

library.add([
  faGift,
  faFileAlt,
  faBrush,
  faBars,
  faCloudUploadAlt,
  faEyeDropper,
  faInstagram,
  faChevronLeft,
  faChevronRight,
  faMapMarkerAlt,
  faStoreAlt,
  faSync,
  faShoppingBag,
  faLock,
  faGlobe,
  faArrowLeft,
  faArrowRight,
  faExclamationCircle,
  faChevronRight,
  faCheck,
  faSearch,
  faChevronDown,
  faChevronUp
]);

import "bootstrap-vue/dist/bootstrap-vue.css";
import "bootstrap/dist/css/bootstrap.css";

Vue.config.productionTip = false;

import { i18n } from "./lang/i18n.js";

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
